import React from 'react';

import { useTheme } from '@material-ui/core/styles';

import {
  Box,
  Button,
  Container,
  Typography,
  Paper,
  Avatar
} from '@material-ui/core';

import Webcam from 'react-webcam';

import CameraAltIcon from '@material-ui/icons/CameraAlt';
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import DebounceTextField from 'src/components/DebounceTextField';
import { all } from 'mathjs';

const FaceScanner = ({
  webcamRef,
  canvasRef,
  capture,
  bioID,
  handleSetBioID,
  allowCapture,
  initFaceMesh
}) => {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <Box mb={3} textAlign="center">
        <Typography
          variant="h5"
          style={{
            fontWeight: 700,
            color: theme.palette.text.primary
          }}
        >
          AI Face Scanner
        </Typography>

        <Typography
          variant="body2"
          style={{
            color: theme.palette.text.secondary,
            marginTop: 6
          }}
        >
          Real-time biometric verification system
        </Typography>
      </Box>

      <Paper
        elevation={4}
        style={{
          width: '100%',
          borderRadius: 24,
          overflow: 'hidden',
          background: `linear-gradient(
            135deg,
            ${theme.palette.primary.dark} 0%,
            ${theme.palette.primary.main} 100%
          )`,
          padding: 20,
          color: theme.palette.primary.contrastText
        }}
      >
        <Container maxWidth="sm">
          <Box
            mb={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box display="flex" alignItems="center">
              <Avatar
                style={{
                  background: theme.palette.secondary.main,
                  width: 42,
                  height: 42,
                  marginRight: 12
                }}
              >
                <CenterFocusStrongIcon />
              </Avatar>

              <Box>
                <Typography
                  variant="subtitle1"
                  style={{
                    color: theme.palette.primary.contrastText,
                    fontWeight: 600
                  }}
                >
                  Biometric Scanner
                </Typography>

                <Typography
                  variant="caption"
                  style={{
                    color: 'rgba(255,255,255,0.75)'
                  }}
                >
                  AI facial recognition active
                </Typography>
              </Box>
            </Box>

            {allowCapture && (
              <Box display="flex" alignItems="center">
                <CheckCircleIcon
                  style={{
                    color: theme.palette.success.main,
                    marginRight: 4
                  }}
                />

                <Typography
                  variant="caption"
                  style={{
                    color: theme.palette.success.main,
                    fontWeight: 700
                  }}
                >
                  READY
                </Typography>
              </Box>
            )}
          </Box>

          <Box
            style={{
              position: 'relative',
              width: '100%',
              height: 350,
              borderRadius: 20,
              overflow: 'hidden',
              border: `3px solid rgba(255,255,255,0.08)`,
              background: '#000',
              boxShadow: theme.shadows[6]
            }}
          >
            <Webcam
              ref={webcamRef}
              audio={false}
              mirrored
              screenshotFormat="image/png"
              videoConstraints={{
                facingMode: 'user'
              }}
              onUserMedia={() => {
                initFaceMesh();
              }}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                zIndex: 1
              }}
            />

            <canvas
              ref={canvasRef}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 2
              }}
            />

            <Box
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: 220,
                height: 280,
                transform: 'translate(-50%, -50%)',
                // border: `2px solid ${
                //   allowCapture
                //     ? theme.palette.success.main
                //     : 'rgba(255,255,255,0.4)'
                // }`,
                border: `2px solid ${'rgba(255,255,255,0.4)'}`,

                borderRadius: 20,
                zIndex: 3,
                // boxShadow: allowCapture
                //   ? `0 0 20px ${theme.palette.success.main}`
                //   : 'none',
                transition: '0.3s'
              }}
            />

            {(!bioID || !allowCapture) && (
              <Box
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '25%',
                  width: '50%',
                  height: 2,
                  background: `linear-gradient(
        90deg,
        transparent,
        ${theme.palette.secondary.main},
        transparent
      )`,
                  boxShadow: `0 0 20px ${theme.palette.secondary.main}`,
                  zIndex: 4,
                  animation: 'scanAnimation 2s linear infinite'
                }}
              />
            )}

            <style>
              {`
                @keyframes scanAnimation {
                  0% {
                    top: 20%;
                  }
                  50% {
                    top: 80%;
                  }
                  100% {
                    top: 20%;
                  }
                }
              `}
            </style>
          </Box>

          {/* <Box mt={3}>
            <DebounceTextField
              type="number"
              value={bioID}
              label="Enter Bio ID"
              fullWidth
              variant="outlined"
              onChange={e => {
                handleSetBioID(e.target.value);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                }
              }}
              InputProps={{
                style: {
                  background: theme.palette.background.paper,
                  borderRadius: 12
                }
              }}
            />
          </Box> */}

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={4}
          >
            <Button
              onClick={capture}
              disabled={!bioID || !allowCapture}
              style={{
                width: 90,
                height: 90,
                minWidth: 90,
                borderRadius: '50%',
                background:
                  !bioID || !allowCapture
                    ? theme.palette.action.disabled
                    : `linear-gradient(
                        135deg,
                        ${theme.palette.secondary.main} 0%,
                        ${theme.palette.primary.light} 100%
                      )`,
                color: '#fff',
                boxShadow:
                  !bioID || !allowCapture
                    ? 'none'
                    : `0 10px 30px ${theme.palette.primary.main}55`,
                transition: '0.3s'
              }}
            >
              <CameraAltIcon
                style={{
                  fontSize: 45
                }}
              />
            </Button>
          </Box>

          <Box mt={2} textAlign="center">
            <Typography
              variant="caption"
              style={{
                color: 'rgba(255,255,255,0.75)'
              }}
            >
              Position your face inside the scanner frame
            </Typography>
          </Box>
        </Container>
      </Paper>
    </Box>
  );
};

export default FaceScanner;
